export const filterDirty = (form, vForm, previous) => {
    const allowed = Object.keys(form).filter(el => el !== 'id')
    const filtered = Object.keys(vForm)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
            obj[key] = vForm[key]
            return obj
        }, {})
    return allowed
        .map(el =>
            filtered[el].$dirty && filtered[el].$model !== previous[el] ? [el, filtered[el].$model] : null
        )
        .filter(Boolean)
        .reduce((acc, [k, v]) => {
            acc[k] = v
            return acc
        }, {})
}